<template>
  <div
    :class="{
      'viewership-block': !isGraphOnly,
    }"
  >
    <div class="viewership-block__header">
      <div>
        <h4>
          Viewership -
          <!--TODO make into a seperate component-->
          <template v-if="!isGraphOnly">
            <toggle-button
              class="viewership-block__toggle-button"
              left-label="Graph"
              right-label="Table"
              :toggle-value="!changeToTable"
              @toggle="toggleDisplayOfData"
            >
            </toggle-button>
          </template>
        </h4>
        <template v-if="!isGraphOnly">
          <small class="viewership-block__tip">*Select networks below to see Daypart breakdowns.</small>
        </template>
      </div>
      <!--TODO slotted area goes here-->
      <template v-if="!isGraphOnly">
        <date-range class="viewership-block__date-range"></date-range>
        <action-button
          v-if="!isTargetActivated && showFilter"
          @click.native="toggleNetworksModal"
          color="secondary"
          id="networksBtn"
          label="Networks"
        />
      </template>
    </div>

    <template v-if="!changeToTable">
      <div class="viewership-block__graph-container">
        <div class="viewership-block__y-title">Index</div>
        <div class="viewership-block__x-title">Rating</div>
        <viewership-graph
          v-if="allowViewershipToRender"
          :chartData="dataForGraph"
          :axises="axises"
          :onClick="viwershipOnClick"
          class="viewership-block__graph"
          ref="viewershipGraph"
        ></viewership-graph>
        <api-error-message
          v-if="!viewershipData"
          api-name="viewership graph data"
        ></api-error-message>
      </div>
    </template>
    <template v-else>
      <div class="viewership-block__table-container">
        <styled-table
          theme="light"
          :data="dataForTable"
          :headers="tableHeaders"
          :sort='{prop: "size", order: "descending"}'
          @sort-change="handleSortChange">

          <!-- Custom formatting for audience size column -->
          <template v-slot:item.size="{ item }">
            {{ formatAudienceSize(item.size) }}
          </template>
        </styled-table>
      </div>
    </template>
    <!--TODO slotted area goes here-->
    <template v-if="!isGraphOnly">
      <viewership-filter
        v-if="!isTargetActivated && showFilter"
        ref="filter"
        :networks="networks"
        :selected-networks="selectedViewershipNetworks"
      ></viewership-filter>
    </template>
  </div>
</template>

<script>
  import { ResizeSensor } from 'css-element-queries'
  import ViewershipGraph from './ViewershipGraph'
  import ToggleButton from '@/components/common/toggleButton'
  import DateRange from '@/appComponents/oldWorkbench/dateRange'
  import ActionButton from '@/components/common/actionButton'
  import ViewershipFilter from './ViewershipFilter.vue'
  import StyledTable from '@/components/common/tables/components/StyledTable.vue'
  import ApiErrorMessage from '@/appComponents/workbench/apiErrorMessage/ApiErrorMessage'
  import { formatIndex, formatRating, formatAudienceSize } from '../helpers'
  import { setDataForBubblesPlugin } from '../../bubbleLabelPlugin'
  import {
    transformHistoricalViewershipGraphData,
    historicalViewershipGraphAxises,
  } from '@/appComponents/workbench/lasGraphs/chartDataHelpers'
  import { map, orderBy } from 'lodash'
  import { SELECT_NETWORK_DAY_PART } from '@/appLogic/targets/currentTarget/store/actions'
  // TODO fix this

  export default {
    components: {
      ViewershipFilter,
      ViewershipGraph,
      DateRange,
      ActionButton,
      ApiErrorMessage,
      ToggleButton,
      StyledTable
    },
    props: {
      viewershipData: {
        type: Object,
      },
      networks: {
        type: Array,
        required: true,
      },
      showFilter: {
        type: Boolean,
        default: true,
      },
      isGraphOnly: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        changeToTable: true,
        tableSorting: {
          prop: 'size',
          order: 'desc',
        },
        networksToHide: [],
        overRideBubble: {
          min: 15,
          max: 90,
        },
        tableHeaders: [
          {
            text: 'Network',
            value: 'name',
            align: 'left',
            sortable: true
          },
          {
            text: 'Audience Size',
            value: 'size',
            align: 'left',
            sortable: true
          }
        ],
        // allowViewershipToRender: false,
        allowViewershipToRender: false,
        headers: [
          {
            text: 'Network',
            align: 'start',
            value: 'name',
          },
          { text: 'Audience Size', value: 'size', align: 'start' },
        ],
      }
    },
    computed: {
      networksToHighlight() {
        return this.$store.getters.networksToShowDayParts || []
      },
      selectedViewershipNetworks() {
        return this.$store.getters.selectedViewershipNetworks
      },
      dataForGraph() {
        return transformHistoricalViewershipGraphData(
          this.networks,
          this.viewershipData,
          this.networksToHighlight,
          this.overRideBubble,
        )
      },
      dataForTable() {
        console.log(
          'dataForTable',
          orderBy(
            map(this.viewershipData, (value, key) => {
              return {
                name: key,
                index: value.index,
                rating: value.rating,
                size: parseFloat(value.size.toFixed(3)),
              }
            }),
            this.tableSorting.prop,
            this.tableSorting.order,
          ),
        )
        return orderBy(
          map(this.viewershipData, (value, key) => {
            return {
              name: key,
              index: value.index,
              rating: value.rating,
              size: parseFloat(value.size.toFixed(3)),
            }
          }),
          this.tableSorting.prop,
          this.tableSorting.order,
        )
      },
      axises() {
        return historicalViewershipGraphAxises(this.viewershipData)
      },
      isTargetActivated() {
        return this.$store.getters.isTargetActivated
      },
    },
    methods: {
      formatIndex,
      formatRating,
      formatAudienceSize,
      toggleDisplayOfData() {
        this.changeToTable = !this.changeToTable
      },
      handleSortChange({ prop, order }) {
        this.tableSorting.prop = prop
        this.tableSorting.order = order === 'descending' ? 'desc' : 'asc'
      },
      toggleNetworksModal() {
        this.$refs.filter.open()
      },
      resizeBubbleToWidth(updatedWidth) {
        if (updatedWidth < 1281) {
          this.overRideBubble.max = 40
          this.overRideBubble.min = 8
        } else if (updatedWidth < 1400) {
          this.overRideBubble.max = 60
          this.overRideBubble.min = 12
        } else if (updatedWidth >= 1700) {
          this.overRideBubble.max = 90
          this.overRideBubble.min = 16
        }
      },
      initResizeOneGraph() {
        if (!this.allowViewershipToRender) {
          this.allowViewershipToRender = true
          this.$nextTick(function () {
            if (this.$refs && this.$refs.viewershipGraph && this.$refs.viewershipGraph.$el) {
              const viewershipGraph = this.$refs.viewershipGraph.$el
              this.resizeBubbleToWidth(viewershipGraph.clientWidth)
              ResizeSensor(viewershipGraph, () => {
                const updatedWidth = viewershipGraph.clientWidth
                this.resizeBubbleToWidth(updatedWidth)
              })
            }
          })
        }
      },
      viwershipOnClick(network) {
        this.$store.dispatch(SELECT_NETWORK_DAY_PART, network)
      },
      resetBubbles() {
        // update the chart draw function with new data
        if (!this.dataForGraph) return
        setDataForBubblesPlugin(this.dataForGraph.datasets)
        this.$nextTick(function () {
          this.initResizeOneGraph()
        })
      },
    },
    mounted() {
      this.resetBubbles()
    },
    watch: {
      viewershipData: function () {
        this.allowViewershipToRender = true
        this.resetBubbles()
      },
      dataForGraph: function () {
        this.resetBubbles()
      },
    },
    beforeDestroy() {
      const viewership = this.$refs.ViewershipGraph
      if (viewership && viewership.$el) {
        ResizeSensor.detach(this.$refs.viewershipGraph.$el)
      }
    },
  }
</script>

<style lang="scss">
  .viewership-block {
    position: absolute;
    top: rem(20);
    left: rem(20);
    right: rem(20);
    bottom: rem(20);

    h4 {
      margin-bottom: 0;
    }

    small {
      color: color(grays, extra-light);
    }

    &__header {
      display: flex;
      flex: 0 0;
      width: 100%;
      align-items: center;
    }

    &__table-container {
      height: calc(100% - 50px);
      overflow: auto;
    }

    &__graph-container {
      flex: 1 1;
      height: calc(100% - 50px);
      position: relative;
      font-weight: bold;
      line-height: rem(13);
      padding-left: rem(25);
      padding-bottom: rem(20);
      font-size: rem(13);
      color: color(grays, light);
      text-transform: uppercase;
    }

    &__graph {
      height: calc(100% - 10px);
    }

    &__y-title {
      position: absolute;
      top: 50%;
      left: rem(-10);
      transform: rotate(-90deg);
    }

    &__x-title {
      bottom: 14px;
      right: 50%;
      position: absolute;
    }

    &__tip {
      line-height: rem(12);
    }

    &__date-range {
      margin-left: auto;
      margin-right: rem(15);
    }
  }
</style>



// WEBPACK FOOTER //
// Viewership.vue?44a19546